var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAcceptUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icAcceptUser") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NOTIFICATIONS",
    transform: "translate(-88.000000, -761.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(0.000000, 590.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UserNotification-Copy-2",
    transform: "translate(0.000000, 117.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(87.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flag-Copy-2",
    transform: "translate(0.000000, 44.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add-User",
    transform: "translate(0.326923, 0.249000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icAcceptUser"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fill: "#2C91D0",
    cx: 9.32692308,
    cy: 9.401,
    rx: 8.65384615,
    ry: 8.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02081517,8.536 C7.23814264,8.536 6.5977525,7.91237237 6.59763314,7.15007042 L6.59763314,6.46181334 C6.59763314,5.69962763 7.23814264,5.076 8.02081517,5.076 L8.36971738,5.076 C9.15250927,5.076 9.79289941,5.69962763 9.79289941,6.46181334 L9.79289941,7.15007042 C9.79289941,7.91237237 9.15238991,8.536 8.36971738,8.536 L8.02081517,8.536 Z M9.30098512,9.401 C10.0127372,9.401 10.591716,9.96551682 10.591716,10.6593844 L10.591716,12.4767678 C10.591716,12.6889921 10.4153016,12.861 10.1976404,12.861 L5.39407558,12.861 C5.17641439,12.861 5,12.6889921 5,12.4767678 L5,10.6593844 C5,9.96551682 5.57897877,9.401 6.2905132,9.401 L9.30098512,9.401 Z M10.7241026,8.33895901 C10.685812,8.30164227 10.6666667,8.24566716 10.6666667,8.20835042 C10.6666667,8.17103368 10.685812,8.11505857 10.7241026,8.07774183 L10.9921368,7.81652464 C11.0687179,7.74189116 11.1835897,7.74189116 11.2601709,7.81652464 L11.2793162,7.83518301 L12.3323077,8.93602686 C12.3705983,8.9733436 12.4280342,8.9733436 12.4663248,8.93602686 L15.0317949,6.34251338 L15.0509402,6.34251338 C15.1275214,6.2678799 15.2423932,6.2678799 15.3189744,6.34251338 L15.5870085,6.60373057 C15.6635897,6.67836405 15.6635897,6.79031427 15.5870085,6.86494775 L12.5237607,9.96223723 C12.4854701,9.99955398 12.4471795,10.0182123 12.3897436,10.0182123 C12.3323077,10.0182123 12.2940171,9.99955398 12.2557265,9.96223723 L10.7623932,8.39493412 L10.7241026,8.33895901 Z",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAcceptUser);
export default __webpack_public_path__ + "static/media/icAcceptUser.b7d64ddeb033b101b9029fddfd08a121.svg";
export { ForwardRef as ReactComponent };